import { useCopyToClipboard } from "@/shared/hooks/useCopyToClipboard";
import useTranslations from "@/shared/lang/useTranslations";

import { PwaInstallCard } from "./PwaInstallCard";
import { usePwaInstallBanner } from "./usePwaInstallBanner";

export function PwaInstallBanner({ enabled }: { enabled: boolean }) {
  const { t } = useTranslations("global");
  const { guide, dismiss, install } = usePwaInstallBanner(enabled);
  const { copiedValue, copy } = useCopyToClipboard(t("pwa_install_copy_error"));

  if (!guide) return null;

  const appLink = `${window.location.origin}/`;

  return (
    <div className="pointer-events-none fixed inset-x-0 bottom-0 z-40 px-3 pb-[max(0.75rem,env(safe-area-inset-bottom))]">
      <PwaInstallCard
        guide={guide}
        linkCopied={copiedValue === appLink}
        onInstall={() => void install()}
        onCopyLink={() => void copy(appLink, t("pwa_install_link_copied"))}
        onDismiss={dismiss}
        className="pointer-events-auto mx-auto max-w-md motion-safe:animate-in motion-safe:duration-300 motion-safe:fade-in motion-safe:slide-in-from-bottom-6"
      />
    </div>
  );
}
